module.exports = __webpack_public_path__ + "img/猫(2).3fd4962a.png";